<template>
    <main class="main">
        <!-- ======= Breadcrumbs ======= -->
        <section id="breadcrumbs" class="breadcrumbs">
            <div class="container">
                <ol>
                <li><a href="/">ACCUEIL</a></li>
                <li>Dossiers SEED</li>
                </ol>
                <h2>REPERTOIRE DES DOSSIERS SEED</h2>

            </div>
        </section><!-- End Breadcrumbs -->
        <div class="container">
            <div class="p-1">
                    <div class=""><router-link class="btn btn-xs btn-danger" to="/owner/seed/create"><i class="bi bi-plus-square-fill" title="Creer un nouveau dossier"></i>Nouveau dossier</router-link></div>
                </div>
            <table class="table table-sm table-bordered">
                <thead>
                    <tr>
                        <th>NOM</th>
                        <th>CONSULTANT</th>
                        <th>PROMOTEUR</th>
                        <th>PROGRESSION</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(dossier,index) in dossiers" :key="index">
                        <td>
                            <router-link :to="{name:'owner_seed', params: {tkn: dossier.token}}">{{ dossier.name }}</router-link>
                        </td>
                        <td>{{ dossier.consultant?dossier.consultant.name:'-' }}</td>
                        <td>{{ dossier.owner?dossier.owner.name:'-' }}</td>
                        <td> <span :class="'badge badge-'+dossier.progression.color"  style="padding:5px; ">  {{ dossier.progression.per }} %</span></td>
                        
                    </tr>
                </tbody>
            </table>
        </div>
    </main>
</template>
<script>
import axios from "axios";
export default {
    name:"IndexPreseed",
    data(){
        return {
            user:this.$store.state.auth.user,
            dossiers:[]
        }
    },
    methods:{
        async load(){
            await axios.get(this.path+'owner/seeds')
                        .then((res)=>this.dossiers=res.data)
                        .catch((err)=>console.error(err));
        }
    },
    mounted(){
        this.load().then(()=>console.log(this.dossiers))
        
    }

}
</script>

<style scoped>
    .badge{
        background-color: #3d9970;
        color: #fff;
    }
    .breadcrumbs a{
        color: #3d9970;
        text-decoration: none;
    }
    a{
        color: #3d9970;
        text-decoration: none;
    }
</style>